import type { Page } from '../../types';

const detailsOfPrevention: Page[] = [
  {
    pageType: 'question',
    title: 'Do you perform any upstream prevention measures?',
    name: 'upstream-prevention',
    description:
      'Where control improvements are made following the insights gained from proactive detection activity (e.g. fraud measurement or data matching exercises) they may generate ‘Upstream Prevention Savings’. Such savings are calculated on the basis of a reduction in the measured level of fraud/error in the particular business area, after the implementation of the additional control measures. Values here can include savings calculated from a reduction in both the fraud and error rate.\n' +
      'The savings methodology used should either be assured by the Prevention Panel, or refer to an approved methodology within the Prevention Panel Methodology Bank',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you perform any upstream prevention measures',
        name: 'prevented_upstream_radio',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
    ],
  },
  {
    pageType: 'list',
    title: 'Add an instance',
    name: 'details-of-prevention',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'prevented_upstream_impact' },
        { title: 'Total Value', field: 'prevented_upstream' },
      ],
    },
    description:
      'Where control improvements are made following the insights gained from proactive detection activity (e.g. fraud measurement or data matching exercises) they may generate ‘Upstream Prevention Savings’. Such savings are calculated on the basis of a reduction in the measured level of fraud/error in the particular business area, after the implementation of the additional control measures. Values here can include savings calculated from a reduction in both the fraud and error rate.\n' +
      'The savings methodology used should either be assured by the Prevention Panel, or refer to an approved methodology within the Prevention Panel Methodology Bank.\n' +
      'Entries should also include selections from the Upstream Prevention typology dropdowns:\n' +
      '<ul><li>the business area affected by the fraud</li><li>the prevention activity or type of control implemented that enabled a saving and/or reduction in the fraud/error rate</li><li>whether the fraud related to a COVID-19 scheme or activity</li></ul><br/>',
    disabled: [
      {
        field: 'prevented_upstream_radio',
        condition: 'equals', // optional
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'select',
        title: 'Which spending area was the fraud prevented in?',
        name: 'prevented_upstream_area',
        detailsHeading: 'Help with spending areas',
        detailsContent:
          ' <b>Benefits:</b> money given by the government to support members of the public' +
          ' <br/><b>Charges & other non-tax income:</b> money owed to public sector organisations (for example, court fines or prescription fees)' +
          ' <br/><b>Grants:</b> money given by a public sector organisation for a specific purpose' +
          ' <br/><b>Licences and permits:</b> licences, permits or certificates that grant permissions (for example, a Blue Badge, Surveyor licence, marriage certificate)' +
          ' <br/><b>Loans & credit guarantees:</b> money loaned or guaranteed by a public sector organisation' +
          ' <br/><b>Personnel:</b> employees (including contractors and agency workers)' +
          ' <br/><b>Procurement:</b> goods or services bought by public sector organisations (including suppliers)' +
          ' <br/><b>Special payments:</b> money given in unique or specific circumstances (for example, compensation)' +
          ' <br/><b>Subsidies:</b> support or incentives given by the government' +
          ' <br/><b>Tax & duties:</b> mandatory government charge for goods, income or services',
        options: [
          'Benefits',
          'Charges & other non-tax income',
          'Grants',
          'Licences and permits',
          'Loans & credit guarantees',
          'Personnel',
          'Procurement',
          'Special payments',
          'Subsidies',
          'Tax & duties',
        ],
        hintOption: 'Please Select',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'What was the prevention activity?',
        name: 'prevented_upstream_support',
        detailsHeading: 'Help with terms',
        detailsContent:
          '<b>Automated compliance checks:</b> using technology to review compliance with eligibility' +
          '</br><b>Behavioural insights:</b> using user behaviour to predict or deter fraudulent activity' +
          '</br><b>Biometrics:</b> using or improving identification using biometrics (for example, fingerprints)' +
          '</br><b>Cyber security:</b> using or improving cyber security systems' +
          '</br><b>Eligibility criteria and rules:</b> using or changing eligibility rules for roles, products or services' +
          '</br><b>External audit or review:</b> independent review by experts of skilled professionals' +
          '</br><b>Governance:</b> using or updating decision-making processes in the organisation e.g. segregation of duties' +
          '</br><b>Manual compliance checks:</b> using manual reviews or investigations to review compliance with eligibility criteria' +
          '</br><b>Risk scoring & Enhanced Due Diligence:</b> using risk scores to enhance due diligence' +
          '</br><b>Training and awareness:</b> improving organisational knowledge and awareness through training e.g. on policies, risks or other communications campaigns',

        options: [
          'Automated compliance checks',
          'Behavioural insights',
          'Biometrics',
          'Cyber security',
          'Eligibility criteria and rules',
          'External audit or review',
          'Governance',
          'Manual compliance checks',
          'Risk scoring & Enhanced Due Diligence',
          'Training and awareness',
        ],
        rules: { required: true },
      },
      {
        questionType: 'instanceInput',
        title: 'How many instances were prevented?',
        name: 'prevented_upstream_impact',
        txt: `Total number of instances.`,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'What is the value of the upstream prevention?',
        name: 'prevented_upstream',
        txt: `Total value`,
        hint: `If a value is not applicable, please enter 0`,
        hideOptionalLabel: true,
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textInput',
        title: 'Enter the methodology number here',
        name: 'prevented_upstream_methodology_number',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'prevented_upstream_comments',
        hint: `Please ensure you do not include any personal or sensitive information`,
        rules: {
          required: false,
        },
      },
      {
        questionType: 'radio',
        title: 'Is this related to Covid 19 activity?',
        name: 'prevented_upstream_c19',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
];
export default detailsOfPrevention;

